// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dateInputContainer{display:flex;align-items:center;border:1px solid #d9d9d9;background-color:#fff;border-radius:0px;overflow:hidden;height:50px;margin-bottom:15px}.dateInput{border:none !important;flex:1 1;height:48px !important;padding:8px 12px;border-radius:0px !important}.dateInput:focus{border:1px solid var(--accent-bg) !important;box-shadow:none}.divider{width:1px;background-color:#d9d9d9;height:70%;margin:0;align-self:center}", ""]);
// Exports
module.exports = exports;
